import * as React from 'react';
var SvgWheel = () => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  width: "1em",
  height: "1em"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M5.543 11.25h3.552a2.998 2.998 0 0 1 .837-1.424L7.826 7.017a6.49 6.49 0 0 0-2.283 4.233ZM9.08 6.19l2.176 2.903a3.006 3.006 0 0 1 1.486 0l2.176-2.902A6.473 6.473 0 0 0 12 5.5c-1.05 0-2.042.249-2.92.69Zm7.093.827-2.106 2.81c.4.38.695.871.838 1.423h3.551a6.489 6.489 0 0 0-2.283-4.233Zm2.283 5.733h-3.552a2.998 2.998 0 0 1-.837 1.424l2.106 2.809a6.489 6.489 0 0 0 2.283-4.233Zm-3.538 5.06-2.176-2.903a3.008 3.008 0 0 1-1.486 0L9.081 17.81c.877.442 1.87.691 2.919.691 1.05 0 2.042-.249 2.92-.69Zm-7.093-.827 2.106-2.81a2.998 2.998 0 0 1-.837-1.423H5.543a6.49 6.49 0 0 0 2.283 4.233Zm3.612-3.592a.748.748 0 0 0-.214-.107 1.5 1.5 0 0 1 0-2.568.748.748 0 0 0 .214-.107 1.496 1.496 0 0 1 1.124 0 .748.748 0 0 0 .214.107 1.5 1.5 0 0 1 0 2.568.748.748 0 0 0-.214.107 1.496 1.496 0 0 1-1.124 0ZM4 12a8 8 0 1 1 16 0 8 8 0 0 1-16 0Z",
  clipRule: "evenodd"
}));
export default SvgWheel;